export default __webpack_public_path__ + "static/media/14_proud_mary.42bd7f05.png";